export const convertEntrataDateFormatToISO = (dateString: string): string => {
  const mmddyyyyPattern = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

  if (!mmddyyyyPattern.test(dateString)) {
    return dateString;
  }

  const [month, day, year] = dateString.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
